import React, { memo, useCallback, useState } from 'react';

import { MainContent } from '../main-content';
import { useRateViewerContext } from '../rate-viewer-context-provider';
import { NewSellerProviderList } from '../seller-provider-list/new-seller-provider-list';

import style from '../rate-viewer.module.less';

const getSelectedSellerProviderId = (rateViewerSellerProviderId, rateGroups) => {
  return !rateViewerSellerProviderId && rateGroups.length > 0 ? rateGroups[0].sellerLabelProviderId : rateViewerSellerProviderId;
};

export const CarriersView = memo(() => {
  const {
    selectedRate,
    updateSelectedRate,
    filteredRateGroups,
    shouldShowLoadingIndicator,
    filteredSellerLabelProviders,
    validationErrors,
  } = useRateViewerContext();

  const [selectedSellerLabelProviderId, setSelectedSellerLabelProviderId] = useState(() =>
    getSelectedSellerProviderId(selectedRate?.sellerLabelProviderId, filteredRateGroups),
  );
  const selectedRateGroup = filteredRateGroups.find(
    (sellerProviderRate) => sellerProviderRate.sellerLabelProviderId === selectedSellerLabelProviderId,
  );

  const selectRate = useCallback(
    (newRate) => {
      updateSelectedRate({
        ...newRate,
        sellerLabelProviderId: selectedSellerLabelProviderId,
      });
    },
    [updateSelectedRate, selectedSellerLabelProviderId],
  );

  return (
    <div className={style['normal-content']}>
      <div className={style['seller-provider-list']}>
        <NewSellerProviderList
          onSellerProviderClicked={setSelectedSellerLabelProviderId}
          selectedSellerProviderId={selectedSellerLabelProviderId}
          sellerLabelProviders={filteredSellerLabelProviders}
          sellerProviderRates={filteredRateGroups}
        />
      </div>
      <MainContent
        isLoading={shouldShowLoadingIndicator}
        onRateSelected={selectRate}
        selectedProvider={selectedRateGroup}
        selectedRate={selectedRate}
        sellerProviderRates={filteredRateGroups}
        validationErrors={validationErrors}
      />
    </div>
  );
});
